"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Pin.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Pin = function Pin(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 205.83 255.86"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Map Pin Icon"), _react2.default.createElement("g", {
    className: "pin-icon",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M102.91 255.86c-4.86 0-12.51-2-28.65-18A313.12 313.12 0 0 1 42 199.47a309.22 309.22 0 0 1-28.94-48.34C4.4 132.57 0 116.34 0 102.91a102.91 102.91 0 1 1 205.83 0c0 33.1-26.58 74.72-42.42 96.58a323.33 323.33 0 0 1-32.25 38.33c-16.08 15.99-23.54 18.04-28.25 18.04zM101.8 236zm2 0zm-.9-216A83 83 0 0 0 20 102.91c0 19.2 13.54 49.87 36.23 82 20.79 29.47 40.11 47.45 46.58 50.6 6.47-3.32 25.78-21.49 46.58-50.84 23.15-32.67 36.43-62.48 36.43-81.8A83 83 0 0 0 102.91 20z",
    className: "pin-outline",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M102.91 162.61a60.41 60.41 0 1 1 60.41-60.41 60.48 60.48 0 0 1-60.41 60.41zm0-100.82a40.41 40.41 0 1 0 40.41 40.41 40.46 40.46 0 0 0-40.41-40.41z",
    className: "inner-circle",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = Pin;